export default __webpack_public_path__ + "static/media/sandeep.b7772068.jpg";